module.exports = __webpack_public_path__ + "img/parcels.942c3dae.svg";